import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';

// common
import { SubscriberComponent } from '@aa/common';
import { timer } from 'rxjs';

const contentList: string[] = [
  'Do you like s21check? AdviceAid could be powering all your housing advice.',
  'Discover why lots of councils are powering all their housing advice with AdviceAid.',
  'Provide this advice directly to customers on your website, with AdviceAid.'
];

function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

@Component({
  selector: 'aa-ad-banner',
  templateUrl: './ad-banner.component.html',
  styleUrls: ['./ad-banner.component.scss']
})
export class AdBannerComponent implements OnInit {

  public contentIndex: number;
  public content: string;
  public active: boolean = true;

  constructor() {
    const source = timer(5000, 5000);
    source.subscribe(() => {
      this.active = !this.active;
      if (this.active) {
        this.next();
      }
    });
  }

  ngOnInit() {
    this.contentIndex = getRandomInt(contentList.length);
    this.content = contentList[this.contentIndex];
  }

  next() {
    this.contentIndex = (this.contentIndex + 1) % contentList.length;
    this.content = contentList[this.contentIndex];
  }
}
